angular.module('bribac.components.ibacEventEditor', [
    'bribac.values',
    'bribac.translations'
])

    .component('ibacEventEditor', {
        templateUrl: 'ibac-event-editor-component.html',
        controller: 'IbacEventEditorCtrl',
        bindings: {
            cancelCallback: '<',
            successCallback: '<',
            eventOpenForEditing: '<'
        }
    })

    .controller('IbacEventEditorCtrl', function () {
        var $ctrl = this
        var now = new Date()
        var tomorrow = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1)

        $ctrl.startDateOptions = {
            minDate: tomorrow
        }

        $ctrl.onSubmit = function () {
            var $form = $ctrl.form

            if ($form._submitting) return
            if ($form.$invalid) {
                $form._submitError = 'formErrors.invalidFields'
                return
            }

            var isoStringMillisecondsRegex = /\.\d{3}/
            $ctrl.editableEvent.date = $ctrl.editableEvent.date.toISOString().replace(isoStringMillisecondsRegex, '')
            $ctrl.successCallback($ctrl.editableEvent)
        }

        $ctrl.$onChanges = function(changes) {
            if (changes.eventOpenForEditing) {
                // Reset state since the iBac event instance we're editing has changed.
                $ctrl.editableEvent = angular.copy($ctrl.eventOpenForEditing)
            }
        }

    })